<div class="department-form">
    <form [formGroup]="form" class="form-content">
        <!-- Name section -->
        <div class="section-title">{{ 'permit.config.departments.form_section_name' | translate }}</div>

        <div class="name-form">
            <app-form-input-v2
                [label]="'permit.config.common.name_fr' | translate"
                placeholder=""
                formControlName="nameFr"
            >
                <app-form-error *ngIf="form.get('nameFr').touched && form.get('nameFr').hasError('required')">
                    {{ 'permit.config.common.required_error' | translate }}
                </app-form-error>
            </app-form-input-v2>

            <app-form-input-v2
                [label]="'permit.config.common.name_en' | translate"
                placeholder=""
                formControlName="nameEn"
            >
                <app-form-error *ngIf="form.get('nameEn').touched && form.get('nameEn').hasError('required')">
                    {{ 'permit.config.common.required_error' | translate }}
                </app-form-error>
            </app-form-input-v2>
        </div>

        <!-- Description section (optional) -->
        <div class="section-title">{{ 'permit.config.departments.form_section_description' | translate }}</div>

        <div class="description-form">
            <app-form-textarea
                [label]="'permit.config.departments.description_fr' | translate"
                [rows]="3"
                formControlName="descriptionFr"
            ></app-form-textarea>

            <app-form-textarea
                [label]="'permit.config.departments.description_en' | translate"
                [rows]="3"
                formControlName="descriptionEn"
            ></app-form-textarea>
        </div>

        <!-- Managers section -->
        <div class="section-title">{{ 'permit.config.departments.form_section_managers' | translate }}</div>

        <div class="managers-form">
            <app-assignee-selector
                [selectedAssigneeIds]="selectedManagerIds"
                [preloadedAdminData]="preloadedManagers"
                [multiSelect]="true"
                (assigneesSelect)="onManagersSelect($event)"
            ></app-assignee-selector>

            <div class="managers-hint">{{ 'permit.config.departments.managers_hint' | translate }}</div>
        </div>

        <!-- Save / Cancel -->
        <div class="form-actions">
            <button type="button" mat-button class="cancel-button" (click)="onCancel()">
                {{ 'permit.config.common.cancel' | translate }}
            </button>
            <button
                type="button"
                mat-flat-button
                class="save-button"
                [disabled]="form.invalid || isSaving"
                (click)="onSave()"
            >
                {{ 'permit.config.common.save' | translate }}
            </button>
        </div>
    </form>
</div>
